module.exports = __webpack_public_path__ + "static/img/blackheads-01.cda224c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/blackheads-01.jpg
// module id = 246
// module chunks = 1